// Client-side image preview + validation for the group/item image upload
// forms. A file input marked with `data-image-preview` drives sibling elements
// with the conventional ids (#image_button, #image_preview,
// #image_preview_container, #image_error); dimension/size limits come from the
// input's data attributes. Replaces three near-identical jQuery snippets.
function wire(input) {
  const button = document.getElementById('image_button')
  const preview = document.getElementById('image_preview')
  const container = document.getElementById('image_preview_container')
  const error = document.getElementById('image_error')
  // Only the button is required. The item form now previews on a canvas and
  // has no #image_preview img; requiring it here meant the whole wiring
  // returned early and the Upload button did nothing at all.
  if (!button) return

  const width = parseInt(input.dataset.previewWidth, 10) || null
  const height = parseInt(input.dataset.previewHeight, 10) || null
  const maxSize = parseInt(input.dataset.previewMaxSize, 10) || null

  const fail = (message) => {
    if (container) container.style.display = 'none'
    input.value = ''
    if (error) {
      error.textContent = message
      error.style.display = ''
    }
  }

  button.addEventListener('click', () => input.click())

  input.addEventListener('change', function () {
    if (error) error.style.display = 'none'
    const file = this.files[0]
    if (!file) return

    const types = ['image/jpeg', 'image/png', 'image/gif']
    if (!types.includes(file.type)) {
      return fail('File must be one of ' + types.map((t) => t.split('/')[1]).join(', ') + '.')
    }
    if (maxSize && file.size > maxSize) {
      return fail('File must be less than ' + maxSize / 1024 + ' kilobytes.')
    }

    const url = URL.createObjectURL(file)
    if (preview) preview.src = url
    if (container) container.style.display = 'block'

    if (width) {
      const probe = new Image()
      probe.onload = function () {
        if (this.width !== width || (height && this.height !== height)) {
          fail('Image dimensions must be ' + width + 'x' + height + '.')
        }
      }
      probe.src = url
    }
  })
}

document.addEventListener('turbo:load', () => {
  document.querySelectorAll('input[data-image-preview]').forEach(wire)
})
